/* GIZA MILLS — PDP interactivity (ports BuyPanel + ProductGallery + SizeGuide + MobileBuyBar).
   Colour/size state, variant resolution, size-aware add-to-cart, gallery dots + lightbox,
   size-guide modal (measurements + fit finder), and PDP analytics (ViewContent / view_item). */
(function () {
  'use strict';
  var rootEl = document.querySelector('[data-gm-pdp]');
  if (!rootEl) return;

  var data = {};
  try { data = JSON.parse(document.getElementById('gm-pdp-data').textContent); } catch (e) { return; }
  var variants = data.variants || [];
  var colorIdx = data.colorIndex;   // option position (0-based) or null
  var sizeIdx = data.sizeIndex;
  var hasSizes = sizeIdx != null && data.sizes && data.sizes.length > 0;

  var state = { color: data.defaultColor || null, size: '' };

  function optVal(v, i) { return (v.options || [])[i]; }
  function variantFor(color, size) {
    return variants.find(function (v) {
      var okC = colorIdx == null || optVal(v, colorIdx) === color;
      var okS = !hasSizes || optVal(v, sizeIdx) === size;
      return okC && okS;
    });
  }
  function sizeAvailable(size) {
    var v = variantFor(state.color, size);
    return v ? v.available : false;
  }

  var $ = function (s) { return rootEl.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(rootEl.querySelectorAll(s)); };

  /* ---------- gallery colour groups ---------- */
  function showGallery(color) {
    $$('[data-gm-gallery-group]').forEach(function (g) {
      g.style.display = (g.getAttribute('data-gm-gallery-group') === color) ? '' : 'none';
    });
    initGalleryDots();
  }

  /* ---------- CTA + mobile bar sync ---------- */
  function syncCTA() {
    var needsSize = hasSizes && !state.size;
    var v = variantFor(state.color, state.size);
    var available = !!v && v.available;
    $$('[data-gm-add-form]').forEach(function (form) {
      var idInput = form.querySelector('[name=id]');
      if (idInput && v) idInput.value = v.id;
      var btn = form.querySelector('[data-gm-cta]');
      if (!btn) return;
      btn.disabled = needsSize || !available;
      var label = needsSize ? form.getAttribute('data-label-size')
        : (available ? form.getAttribute('data-label-add') : form.getAttribute('data-label-sold'));
      btn.textContent = label;
      // analytics payload kept fresh with the chosen variant
      form.setAttribute('data-gm-analytics', JSON.stringify({
        title: data.title, price: v ? v.price / 100 : data.price, currency: data.currency,
        handle: data.handle, variant: state.color, image: data.image, url: data.url
      }));
    });
    if (window.GIZA && window.GIZA._syncMobileLabel) window.GIZA._syncMobileLabel();
  }

  /* ---------- swatches + sizes ---------- */
  function selectColor(color) {
    state.color = color;
    $$('[data-gm-swatch]').forEach(function (b) {
      var on = b.getAttribute('data-gm-swatch') === color;
      b.classList.toggle('outline', on); b.classList.toggle('outline-[1.5px]', on);
      b.classList.toggle('outline-offset-[3px]', on); b.classList.toggle('outline-ink', on);
      b.classList.toggle('opacity-80', !on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var nameEl = $('[data-gm-color-name]'); if (nameEl) nameEl.textContent = color;
    // refresh size availability strikethroughs
    $$('[data-gm-size]').forEach(function (b) {
      var s = b.getAttribute('data-gm-size');
      var ok = sizeAvailable(s);
      b.disabled = !ok;
      b.classList.toggle('cursor-not-allowed', !ok);
    });
    showGallery(color);
    syncCTA();
  }
  function selectSize(size) {
    state.size = size;
    $$('[data-gm-size]').forEach(function (b) {
      var on = b.getAttribute('data-gm-size') === size;
      b.classList.toggle('bg-ink', on); b.classList.toggle('text-paper', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    syncCTA();
  }
  window.GIZA = window.GIZA || {};
  window.GIZA.selectSize = selectSize;

  function bind() {
    $$('[data-gm-swatch]').forEach(function (b) { b.addEventListener('click', function () { selectColor(b.getAttribute('data-gm-swatch')); }); });
    $$('[data-gm-size]').forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled) selectSize(b.getAttribute('data-gm-size')); }); });
    // accordion
    $$('[data-gm-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.classList.toggle('grid-rows-[1fr]', !open), panel.classList.toggle('grid-rows-[0fr]', open), panel.classList.toggle('pb-6', !open);
        var sign = btn.querySelector('[data-gm-acc-sign]'); if (sign) sign.textContent = open ? '+' : '−';
      });
    });
    // mobile bar reveal
    var cta = document.getElementById('pdp-cta'); var bar = $('[data-gm-mobilebar]');
    if (cta && bar && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) {
        var hidden = e[0].isIntersecting;
        bar.classList.toggle('translate-y-full', hidden); bar.classList.toggle('pointer-events-none', hidden);
        bar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      }, { threshold: 0 });
      io.observe(cta);
    }
    // mobile bar: no size yet → scroll to the options; size chosen → add via the main form
    $$('[data-gm-mobile-cta]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (hasSizes && !state.size) { var c = document.getElementById('pdp-cta'); if (c) c.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        var f = rootEl.querySelector('[data-gm-add-form]'); if (f && f.requestSubmit) f.requestSubmit(); else if (f) f.submit();
      });
    });
    function syncMobileLabel() {
      $$('[data-gm-mobile-cta]').forEach(function (b) {
        var needsSize = hasSizes && !state.size;
        var v = variantFor(state.color, state.size); var available = !!v && v.available;
        b.textContent = needsSize ? b.getAttribute('data-label-size') : (available ? b.getAttribute('data-label-add') : b.getAttribute('data-label-sold'));
      });
    }
    window.GIZA._syncMobileLabel = syncMobileLabel;
  }

  /* ---------- gallery dots + lightbox ---------- */
  var dotObserver;
  function initGalleryDots() {
    if (dotObserver) dotObserver.disconnect();
    var group = document.querySelector('[data-gm-gallery-group]:not([style*="display: none"])') || document.querySelector('[data-gm-gallery-group]');
    if (!group) return;
    var imgs = group.querySelectorAll('[data-img-idx]');
    var count = imgs.length;
    var counterEl = document.querySelector('[data-gm-gallery-counter]');
    if (counterEl) { counterEl.style.display = count > 1 ? '' : 'none'; counterEl.textContent = '1 / ' + count; }

    // (Re)build one dot per image in the VISIBLE colour group, in each dot container (mobile + desktop).
    $$('[data-gm-dots]').forEach(function (c) {
      c.innerHTML = '';
      var desktop = c.hasAttribute('data-gm-dots-desktop');
      for (var i = 0; i < count; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-gm-dot', i);
        b.setAttribute('aria-label', 'Go to image ' + (i + 1));
        b.className = 'block h-[6px] w-[6px] rounded-full bg-ink/25 transition-all duration-300 ease-out' + (desktop ? ' pointer-events-auto hover:bg-ink/55' : ' gm-dot-m');
        (function (idx) {
          b.onclick = function () { var t = group.querySelectorAll('[data-img-idx]')[idx]; if (t) t.scrollIntoView({ behavior: 'smooth', block: window.matchMedia('(min-width:768px)').matches ? 'center' : 'nearest', inline: 'center' }); };
        })(i);
        c.appendChild(b);
      }
    });

    var dots = $$('[data-gm-dot]');
    function setActive(best) {
      dots.forEach(function (d) {
        var di = +d.getAttribute('data-gm-dot'), on = di === best, m = d.classList.contains('gm-dot-m');
        d.classList.toggle('bg-ink', on); d.classList.toggle('bg-ink/25', !on);
        d.classList.toggle('w-4', on && m); d.classList.toggle('w-[6px]', !(on && m));
      });
      if (counterEl && best >= 0) counterEl.textContent = (best + 1) + ' / ' + count;
    }
    setActive(0);
    if (!('IntersectionObserver' in window)) return;
    var vis = new Map();
    dotObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var i = +en.target.getAttribute('data-img-idx');
        if (en.isIntersecting) vis.set(i, en.intersectionRatio); else vis.delete(i);
      });
      var best = -1, br = -1; vis.forEach(function (r, i) { if (r > br) { br = r; best = i; } });
      if (best >= 0) setActive(best);
    }, { threshold: [0, .25, .5, .75, 1], rootMargin: '0px' });
    imgs.forEach(function (im) { dotObserver.observe(im); });
  }
  function initLightbox() {
    var lb = $('[data-gm-lightbox]'); if (!lb) return;
    var imgEl = lb.querySelector('[data-gm-lightbox-img]');
    var stage = lb.querySelector('[data-gm-lb-stage]') || imgEl;
    var track = lb.querySelector('[data-gm-lb-track]');
    var counter = lb.querySelector('[data-gm-lb-counter]');
    var nextBtn = lb.querySelector('[data-gm-lb-next]'), prevBtn = lb.querySelector('[data-gm-lb-prev]');
    var nav = [nextBtn, prevBtn].filter(Boolean);
    var srcs = [], cur = 0, z = 1, tx = 0, ty = 0, MAXZ = 3.2;

    function collect() {
      var g = document.querySelector('[data-gm-gallery-group]:not([style*="display: none"])') || document.querySelector('[data-gm-gallery-group]');
      srcs = g ? Array.prototype.map.call(g.querySelectorAll('img'), function (im) { return im.getAttribute('data-zoom') || im.src; }) : [];
    }
    function preload(i) { var k = (i + srcs.length) % srcs.length; if (srcs[k]) { var im = new Image(); im.src = srcs[k]; } }
    function applyT(anim) {
      stage.style.transition = anim ? 'transform .3s cubic-bezier(.16,1,.3,1)' : 'transform 0s';
      stage.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + z + ')';
      lb.classList.toggle('is-zoomed', z > 1.01);
    }
    function clamp() {
      var bw = imgEl.clientWidth * z, bh = imgEl.clientHeight * z;
      var mx = Math.max(0, (bw - window.innerWidth) / 2 + 24), my = Math.max(0, (bh - window.innerHeight) / 2 + 24);
      tx = Math.max(-mx, Math.min(mx, tx)); ty = Math.max(-my, Math.min(my, ty));
    }
    function resetZoom(anim) { z = 1; tx = 0; ty = 0; applyT(anim); }
    function setZoom(nz, cx, cy) {
      nz = Math.max(1, Math.min(MAXZ, nz));
      var rect = imgEl.getBoundingClientRect();
      var ox = cx - (rect.left + rect.width / 2), oy = cy - (rect.top + rect.height / 2), ratio = nz / z;
      tx -= ox * (ratio - 1); ty -= oy * (ratio - 1);
      z = nz; clamp(); applyT(true);
    }
    // Snappy nav: neighbours are preloaded, so the swap decodes from cache — quick crossfade.
    function show(i, instant) {
      cur = (i + srcs.length) % srcs.length;
      resetZoom(false);
      var single = srcs.length < 2;
      nav.forEach(function (b) { b.style.display = single ? 'none' : ''; });
      if (counter) { counter.style.display = single ? 'none' : ''; counter.textContent = (cur + 1) + ' / ' + srcs.length; }
      var done = function () { imgEl.style.opacity = '1'; preload(cur + 1); preload(cur - 1); };
      if (instant) { imgEl.src = srcs[cur]; imgEl.style.opacity = '1'; preload(cur + 1); preload(cur - 1); return; }
      imgEl.style.opacity = '0';
      var swap = function () { imgEl.src = srcs[cur]; if (imgEl.decode) imgEl.decode().then(done).catch(done); else done(); };
      setTimeout(swap, 55);
    }
    function open(i) {
      collect(); if (!srcs.length) return;
      lb.classList.remove('hidden');
      requestAnimationFrame(function () { lb.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      show(i, true);
    }
    function close() { lb.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(function () { lb.classList.add('hidden'); resetZoom(false); }, 300); }
    function go(d) { if (z > 1.01) { resetZoom(true); return; } if (srcs.length > 1) show(cur + d); }

    rootEl.addEventListener('click', function (e) { var zb = e.target.closest('[data-gm-zoom]'); if (zb) { e.preventDefault(); open(+zb.getAttribute('data-gm-zoom')); } });
    lb.querySelectorAll('[data-gm-lb-close]').forEach(function (b) { b.onclick = close; });
    if (nextBtn) nextBtn.onclick = function (e) { e.stopPropagation(); show(cur + 1); };
    if (prevBtn) prevBtn.onclick = function (e) { e.stopPropagation(); show(cur - 1); };
    document.addEventListener('keydown', function (e) {
      if (lb.classList.contains('hidden')) return;
      if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') go(1); else if (e.key === 'ArrowLeft') go(-1);
    });

    // Desktop: double-click toggles zoom at the cursor, wheel zooms, drag pans when zoomed.
    imgEl.addEventListener('dblclick', function (e) { e.preventDefault(); if (z > 1.01) resetZoom(true); else setZoom(2.4, e.clientX, e.clientY); });
    imgEl.addEventListener('wheel', function (e) { e.preventDefault(); setZoom(z + (e.deltaY < 0 ? .35 : -.35), e.clientX, e.clientY); }, { passive: false });
    var md = false, mx0 = 0, my0 = 0, mtx = 0, mty = 0;
    imgEl.addEventListener('mousedown', function (e) { if (z <= 1.01) return; e.preventDefault(); md = true; mx0 = e.clientX; my0 = e.clientY; mtx = tx; mty = ty; });
    window.addEventListener('mousemove', function (e) { if (!md) return; tx = mtx + (e.clientX - mx0); ty = mty + (e.clientY - my0); clamp(); applyT(false); });
    window.addEventListener('mouseup', function () { md = false; });

    // Touch: pinch-zoom, drag-to-pan when zoomed, horizontal swipe to navigate, double-tap zoom, tap dim to close.
    var sx = 0, sy = 0, stx = 0, sty = 0, moved = 0, pinch = false, sd = 0, sz = 1, lastTap = 0;
    function D(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
    track.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) { pinch = true; sd = D(e.touches[0], e.touches[1]); sz = z; }
      else if (e.touches.length === 1) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; stx = tx; sty = ty; moved = 0; }
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (pinch && e.touches.length === 2) {
        var m = { clientX: (e.touches[0].clientX + e.touches[1].clientX) / 2, clientY: (e.touches[0].clientY + e.touches[1].clientY) / 2 };
        setZoom(sz * (D(e.touches[0], e.touches[1]) / sd), m.clientX, m.clientY);
      } else if (e.touches.length === 1) {
        var t = e.touches[0]; moved = Math.hypot(t.clientX - sx, t.clientY - sy);
        if (z > 1.01) { tx = stx + (t.clientX - sx); ty = sty + (t.clientY - sy); clamp(); applyT(false); }
      }
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (pinch) { if (e.touches.length < 2) { pinch = false; if (z < 1.06) resetZoom(true); } return; }
      if (e.touches.length) return;
      var ct = e.changedTouches[0], dx = ct.clientX - sx, dy = ct.clientY - sy;
      if (z <= 1.01) {
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { show(cur + (dx < 0 ? 1 : -1)); return; }
        if (moved < 10) { var now = Date.now(); if (now - lastTap < 300) { setZoom(2.4, ct.clientX, ct.clientY); lastTap = 0; } else lastTap = now; }
      } else if (moved < 10) {
        var now2 = Date.now(); if (now2 - lastTap < 300) { resetZoom(true); lastTap = 0; } else lastTap = now2;
      }
    });
    track.addEventListener('click', function (e) { if (e.target === track && z <= 1.01) close(); });
    window.addEventListener('resize', function () { if (z > 1.01) { clamp(); applyT(false); } });
  }

  /* ---------- size guide modal ---------- */
  function initSizeGuide() {
    var modal = $('[data-gm-sizeguide]'); if (!modal) return;
    function open(tab) { modal.classList.remove('hidden'); document.body.style.overflow = 'hidden'; setTab(tab || 'm'); }
    function close() { modal.classList.add('hidden'); document.body.style.overflow = ''; }
    function setTab(t) {
      modal.querySelectorAll('[data-gm-sg-tab]').forEach(function (b) { var on = b.getAttribute('data-gm-sg-tab') === t; b.classList.toggle('text-ink', on); b.classList.toggle('text-ink-3', !on); var u = b.querySelector('[data-gm-sg-underline]'); if (u) u.style.display = on ? '' : 'none'; });
      modal.querySelectorAll('[data-gm-sg-panel]').forEach(function (p) { p.style.display = p.getAttribute('data-gm-sg-panel') === t ? '' : 'none'; });
    }
    $$('[data-gm-sizeguide-open]').forEach(function (b) { b.addEventListener('click', function () { open(b.getAttribute('data-tab')); }); });
    modal.querySelectorAll('[data-gm-sg-close]').forEach(function (b) { b.onclick = close; });
    modal.querySelectorAll('[data-gm-sg-tab]').forEach(function (b) { b.onclick = function () { setTab(b.getAttribute('data-gm-sg-tab')); }; });
    // unit toggle (cm/in) for the measurements table
    modal.querySelectorAll('[data-gm-sg-unit]').forEach(function (b) {
      b.onclick = function () {
        var u = b.getAttribute('data-gm-sg-unit');
        modal.querySelectorAll('[data-gm-sg-unit]').forEach(function (x) { var on = x.getAttribute('data-gm-sg-unit') === u; x.classList.toggle('bg-ink', on); x.classList.toggle('text-paper', on); });
        modal.querySelectorAll('[data-cm]').forEach(function (c) { c.textContent = u === 'cm' ? c.getAttribute('data-cm') : c.getAttribute('data-in'); });
      };
    });
    // fit finder
    var h = modal.querySelector('[data-gm-sg-height]'), w = modal.querySelector('[data-gm-sg-weight]');
    var build = '', result = modal.querySelector('[data-gm-sg-result]'), recVal = modal.querySelector('[data-gm-sg-rec]'), useBtn = modal.querySelector('[data-gm-sg-use]'), placeholder = modal.querySelector('[data-gm-sg-placeholder]');
    var rows = data.sizeRows || [];
    var ADJ = { slim: -5, athletic: 2, regular: 0, fuller: 5 };
    function band(s) { return s.split('–').map(parseFloat); }
    function recommend() {
      var hc = h && h.value ? +h.value : 0, wk = w && w.value ? +w.value : 0;
      if (!hc || !wk || !build) { if (result) result.style.display = 'none'; if (placeholder) placeholder.style.display = ''; return; }
      var est = 98 + (wk - 75) * 0.6 - (hc - 175) * 0.2 + (ADJ[build] || 0);
      var idx = rows.findIndex(function (r) { var b = band(r.chestFit); return est >= b[0] && est <= b[1]; });
      if (idx === -1) idx = est < band(rows[0].chestFit)[0] ? 0 : rows.length - 1;
      var rec = rows[idx].size;
      if (placeholder) placeholder.style.display = 'none';
      if (result) result.style.display = '';
      if (recVal) recVal.textContent = rec;
      if (useBtn) useBtn.onclick = function () {
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'fit_finder_used', product: data.handle, recommended: rec }); } catch (e) {}
        selectSize(rec); close();
      };
    }
    if (h) h.onchange = recommend; if (w) w.onchange = recommend;
    modal.querySelectorAll('[data-gm-sg-build]').forEach(function (b) {
      b.onclick = function () { build = b.getAttribute('data-gm-sg-build'); modal.querySelectorAll('[data-gm-sg-build]').forEach(function (x) { var on = x === b; x.classList.toggle('border-ink', on); x.classList.toggle('bg-tile/50', on); }); recommend(); };
    });
  }

  /* ---------- analytics: ViewContent / view_item / Viewed Product ---------- */
  function fireView() {
    var p = { title: data.title, price: data.price, currency: data.currency, handle: data.handle, image: data.image, url: data.url };
    if (window.GIZA.fbq) window.GIZA.fbq('ViewContent', { content_name: p.title, content_ids: [p.handle], content_type: 'product', value: p.price, currency: p.currency });
    if (window.GIZA.gtag) window.GIZA.gtag('view_item', { currency: p.currency, value: p.price, items: [{ item_id: p.handle, item_name: p.title, price: p.price }] });
    if (window.GIZA.klaviyo) window.GIZA.klaviyo('Viewed Product', { ProductName: p.title, ProductID: p.handle, Price: p.price, CurrencyCode: p.currency, ImageURL: p.image, URL: p.url });
  }

  function init() {
    bind(); initGalleryDots(); initLightbox(); initSizeGuide();
    if (state.color) selectColor(state.color); else syncCTA();
    fireView();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
